<nav class="navbar navbar-expand-lg config-top-navbar px-3 px-lg-4 py-3">
  <div class="container-fluid px-0 d-flex align-items-center gap-3">
    <button
      v-if="!hide_hamburger"
      class="btn d-flex d-lg-none align-items-center justify-content-center p-0 border-0 bg-transparent"
      @click="$emit('toggle-sidebar')"
      aria-label="Open menu"
    >
      <i class="bi bi-list fs-3 text-dark"></i>
    </button>

    <div class="config-navbar-brand d-inline-flex align-items-center flex-shrink-0" aria-label="Workspace brand">
      <div class="config-navbar-brand-copy">
        <div class="config-navbar-brand-label">{{ role_label }}</div>
      </div>
    </div>

    <div class="flex-grow-1"></div>

    <div class="ms-auto d-flex align-items-center gap-2 gap-lg-3">
      <div class="config-navbar-profile d-flex align-items-center">
        <span
          class="config-navbar-user-pill text-decoration-none d-inline-flex align-items-center"
          aria-label="User profile"
        >
          <span class="config-navbar-initials rounded-circle d-inline-flex align-items-center justify-content-center fw-bold">
            {{ user_initials }}
          </span>
          <span class="config-navbar-name fw-semibold">{{ user_name }}</span>
        </span>
      </div>
    </div>
  </div>
</nav>
